import { ProgressEvent } from 'src/app/interfaces/progress-event.interface';

export function antiSpam(lastAtMs?: number, nowMs?: number, minGapMs = 2000): boolean {
  if (!lastAtMs || !nowMs) return true;
  return (nowMs - lastAtMs) >= minGapMs;
}

export function toMMSS(deltaMs: number): string {
  const s = Math.max(0, Math.floor(deltaMs / 1000));
  const mm = String(Math.floor(s / 60)).padStart(2, '0');
  const ss = String(s % 60).padStart(2, '0');
  return `${mm}:${ss}`;
}

let _ctr = 0;
export function makeEventId(prefix: string = 'evt'): string {
  _ctr += 1;
  return `${prefix}_${Date.now()}_${_ctr}`;
}

const QUEUE_KEY = 'eva_event_queue_v1';

function readQueue(): ProgressEvent[] {
  try {
    const raw = localStorage.getItem(QUEUE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed) ? (parsed as ProgressEvent[]) : [];
  } catch {
    return [];
  }
}

function writeQueue(events: ProgressEvent[]): void {
  try {
    localStorage.setItem(QUEUE_KEY, JSON.stringify(events));
  } catch {
    // noop
  }
}

export function enqueueEvent(evt: ProgressEvent): void {
  const arr = readQueue();
  arr.push(evt);
  writeQueue(arr);
}

export function flushQueue(
  sendFn: (events: ProgressEvent[]) => Promise<unknown>
): void {
  const arr = readQueue();
  if (!arr.length) return;

  writeQueue([]);

  sendFn(arr).catch(() => {
    const again = readQueue();
    writeQueue([...arr, ...again]);
  });
}
